<template>
  <BreadCrumb PageTitle="Modification de mot de passe" />
  <CoverImage />
  <EditPassword />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CoverImage from "../../components/Generals/CoverImage.vue";
import EditPassword from "../../components/Generals/AccountSettings/EditPassword.vue";

export default defineComponent({
  name: "EditPasswordPage",
  components: {
    BreadCrumb,
    CoverImage,
    EditPassword,
  },
});
</script>